// import React, { Component } from "react";
// import { useSelector } from "react-redux";
import Highcharts from 'highcharts/highmaps';
// import MapWorld from "helpers/MapWorld";
// import MapWorld from '@highcharts/map-collection/custom/world'
import proj4 from 'proj4'


import { Component, useState } from "react"
window.Highcharts = Highcharts
window.proj4 = proj4 

// const MapWorld = require('@highcharts/map-collection/custom/world');


class CMapHighcharts extends Component {
  id = 'genericchartmap'
  state = {
    init: false,
    container: false,
    
  }
  constructor (props) {
    super(props)
    this.id = this.props.id || this.id
    
  }
  componentDidUpdate (props, state) {
    
    if (this.state.container !== false && this.state.init) {
      Highcharts.setOptions({
        lang: {
            thousandsSep: '.',
            decimalPoint: ','
        }
      });
      var chart = Highcharts.mapChart(this.id, this.props.options);
      
      

      this.props.callbackchart(chart)
    }
  }


  componentDidMount (props, state) {
    setTimeout(() => {
      this.setState({
        init: true,
        container: <div id={ this.id }></div>
      })
      
    }, 500)
  }
  render () {
    return (
      this.state.init ? this.state.container : (this.props.loader ? this.props.loader : <h1>Cargando</h1>)
    )
  } 
}

export default CMapHighcharts